<template>
  <v-container
    id="data-management"
    tag="section"
  >
    <base-resource-grid
      ref="resourceGrid"
      color="light-blue accent-3"
      icon="mdi-playlist-edit"
      plural-name="Enrollers"
      singular-name="Enroller"
      allow-expand
      fullscreen-edit
      :headers="headers"
      :resource="enrollerResource"
      :actions="actions"
      @handleAction="handleAction"
    >
      <template v-slot:editForm="editForm">
        <v-row>
          <v-col
            cols="12"
          >
            <enroller-wizard
              :edited-item="editForm.editedItem"
              @enroller:saved="enrollerSaved"
              @wizard:finished="closeEditDialog"
            />
          </v-col>
        </v-row>
      </template>
      <template v-slot:actionButtons>
        <v-card-actions>
          <v-spacer />
        </v-card-actions>
      </template>
    </base-resource-grid>
    <base-history-dialog
      id-field="enrollerId"
      title-field="enrollerName"
      color="light-blue accent-2"
      :resource-endpoint="historyEndpoint"
      :columns="historyHeaders"
      :item="historyItem"
      @hide="historyItem = null"
    >
      <template v-slot:header>
        <v-card>
          <v-tabs
            background-color="light-blue accent-4"
            center-active
            center
          >
            <v-tab
              @click="setHistoryTab('enroller')"
            >
              Enroller
            </v-tab>
            <v-tab
              @click="setHistoryTab('details')"
            >
              Details
            </v-tab>
          </v-tabs>
        </v-card>
      </template>
    </base-history-dialog>
  </v-container>
</template>

<script>
  import TroodyApi from '@/services/troody/TroodyApi'

  export default {
    name: 'Enrollers',

    components: {
      EnrollerWizard: () => import('./components/EnrollerWizard'),
    },

    data: () => ({
      historyTab: 'enroller',

      headers: [
        {
          text: 'First Name',
          value: 'firstName',
        },
        {
          text: 'Last Name',
          value: 'lastName',
        },
        {
          text: 'Email',
          value: 'email',
        },
      ],

      detailsHeaders: [
        {
          text: 'Broker',
          value: 'broker',
        },
        {
          text: 'Carrier',
          value: 'carrier',
        },
        {
          text: 'Writing #',
          value: 'writingNumber',
        },
      ],

      actions: [
        {
          color: 'info',
          icon: 'mdi-information-variant',
          action: 'history',
        },
      ],

      enrollerResource: new TroodyApi('enroller/'),

      historyItem: null,
    }),

    computed: {
      historyHeaders () {
        return this.historyTab === 'details' ? this.detailsHeaders : this.headers
      },

      historyEndpoint () {
        return this.historyTab === 'details' ? 'enrollerDetailHistory/' : 'enrollerHistory/'
      },
    },

    methods: {
      setHistoryTab (tab) {
        this.historyTab = tab
      },

      closeEditDialog () {
        this.$refs.resourceGrid.close()
      },

      enrollerSaved (data) {
        this.$refs.resourceGrid.itemEdited(data)
      },

      handleAction (action, data) {
        if (action === 'history') {
          this.historyItem = data
        }
      },
    },
  }
</script>
